<section
  class="bg-white h-[calc(100vh-120px)] overflow-hidden rounded-t-2xl shadow-md"
>
  <div class="h-full overflow-y-auto overflow-x-hidden">
    <div>
      <div
        class="font-light px-4 pt-2 sticky top-0 bg-white z-20 border-b border-blue-950"
      >
        <div class="flex items-center justify-between mb-2">
          <span class="flex items-center">
            <mat-icon svgIcon="billing" class="text-blue-950"></mat-icon>
            <h1 class="text-3xl font-light whitespace-nowrap ml-2">Invoices</h1>
          </span>
          @if (invoices.length > 5) {
            <mat-form-field>
              <mat-select
                [(value)]="invoiceSelectedFilter"
                (selectionChange)="onInvoiceFilterSelect($event)"
              >
                @for (filter of filters; track filter.value) {
                  <mat-option [value]="filter.value">
                    {{ filter.text }} INVOICES
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      </div>

      @if (isInvoicesLoading) {
        <div class="flex justify-center items-center">
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>
      }
      <div class="list-scroll">
        @if (invoices.length === 0 && !isInvoicesLoading) {
          <div
            class="font-light text-center w-full py-8 relative after:block after:h-px after:bg-gray-500 after:mt-8"
          >
            There are no invoices available for this account yet.
          </div>
        }
        @for (invoice of invoices; track invoice.ContentDocument.Title) {
          <div
            tabindex="0"
            class="list-row relative flex group items-center cursor-pointer hover:bg-blue-50 focus:bg-blue-50 transition-colors duration-200 border-b border-gray-200"
            [class.bg-blue-50]="
              invoice.ContentDocumentId === selectedInvoice.ContentDocumentId
            "
            [class.selected]="
              invoice.ContentDocumentId === selectedInvoice?.ContentDocumentId
            "
            (click)="onSelect(invoice)"
            (keyup.enter)="onSelect(invoice)"
          >
            <div
              class="flex justify-between flex-wrap font-light pr-4 pl-5 items-center relative w-full px-5 py-3"
            >
              <!-- Date -->
              <div class="flex-1 text-md">
                <label
                  class="hidden md:flex font-semibold uppercase text-xs pb-1"
                  >Date Posted</label
                >
                <label
                  class="flex md:hidden font-semibold uppercase text-xs pb-1"
                  >Posted</label
                >
                {{
                  invoice.ContentDocument.Title.slice(0, 10)
                    | date: 'yyyy-MM-dd'
                }}
              </div>

              <!-- Sliding PDF button -->
              <button
                class="absolute top-1/2 right-12 z-10 flex h-9 w-9 translate-x-16 -translate-y-1/2 transform items-center justify-center rounded-full transition-all duration-500 ease-out opacity-0 group-hover:translate-x-0 group-focus-within:translate-x-0 group-hover:opacity-100 group-focus-within:opacity-100 group-[.selected]:translate-x-0 group-[.selected]:opacity-100 hover:bg-blue-100 focus:outline-none"
                [ngClass]="'download-button' | gainsight: 'billing'"
                (click)="onDownload(invoice); $event.stopPropagation()"
              >
                <mat-icon svgIcon="pdf-file" class="text-blue-500"></mat-icon>
              </button>

              <!-- Arrow (always visible) -->
              <mat-icon
                class="text-blue-500 text-sm font-bold relative z-0"
                fontIcon="arrow_forward_ios"
              ></mat-icon>
            </div>
          </div>
        }
      </div>
    </div>

    <div>
      <div
        class="font-light px-4 pt-2 sticky top-0 bg-white z-10 border-b border-blue-950"
      >
        <div class="flex items-center justify-between mb-2">
          <span class="flex items-center">
            <mat-icon svgIcon="billing" class="text-blue-950"></mat-icon>
            <h1 class="text-3xl font-light whitespace-nowrap ml-2">Payments</h1>
          </span>
          @if (payments.length > 5) {
            <mat-form-field>
              <mat-select
                [(value)]="paymentSelectedFilter"
                (selectionChange)="onPaymentFilterSelect($event)"
              >
                @for (filter of filters; track filter.value) {
                  <mat-option [value]="filter.value">
                    {{ filter.text }} PAYMENTS</mat-option
                  >
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      </div>

      @if (isPaymentsLoading) {
        <div class="flex justify-center items-center">
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>
      }
      <div class="list-scroll">
        @if (payments.length === 0 && !isPaymentsLoading) {
          <div
            class="font-light text-center w-full py-8 relative after:block after:h-px after:bg-gray-500 after:mt-8"
          >
            There are no payments available for this account yet.
          </div>
        }
        @if (payments.length > 0 && payments.length !== 0) {
          @for (payment of payments; track payment) {
            <div
              tabindex="0"
              class="list-row relative flex items-center border-b border-gray-200"
            >
              <div
                class="flex justify-between flex-wrap font-light pr-4 pl-5 items-center relative w-full px-5 py-3"
              >
                <div class="flex-1 text-md">
                  <label
                    class="hidden md:flex font-semibold uppercase text-xs pb-1"
                    >Date Posted</label
                  >
                  <label
                    class="flex md:hidden font-semibold uppercase text-xs pb-1"
                    >Posted</label
                  >
                  {{ payment.Transaction_Date__c | date: 'yyyy-MM-dd' }}
                </div>

                <div class="text-lg font-bold">
                  {{
                    payment.Transaction_Amount__c
                      | positiveNumber
                      | currency: 'USD'
                  }}
                </div>
              </div>
            </div>
          }
        } @else if (payments.length !== 0) {
          <div class="list-empty text-center py-4">
            There are no payments available based on the filter selection.
          </div>
        }
      </div>
    </div>

    <app-help-cta
      [originPage]="'Billing'"
      class="block md:hidden"
    ></app-help-cta>
  </div>
</section>
